import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { Users, UserCheck } from 'lucide-react';
import { useDashboardMetrics } from '@/hooks/queries/useDashboard';
import { WidgetSkeleton, WidgetError } from './WidgetSkeleton';

export function ClientesWidget() {
  const { data, isLoading, isError } = useDashboardMetrics();

  if (isLoading) return <WidgetSkeleton />;
  if (isError || !data) return <WidgetError message="Error al cargar clientes" />;

  const porcentajeActivos = data.clientes.total > 0
    ? Math.round((data.clientes.activos / data.clientes.total) * 100)
    : 0;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          Clientes
        </CardTitle>
        <div className="p-2 bg-cyan-50 rounded-lg">
          <Users className="h-4 w-4 text-cyan-600" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{data.clientes.total}</div>
        <div className="flex items-center gap-1 mt-1">
          <UserCheck className="h-3 w-3 text-green-500" />
          <p className="text-xs text-gray-500">
            {porcentajeActivos}% activos ({data.clientes.activos})
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
